import styled from '@emotion/styled';
import { Stack } from '@pairy/pds-react';

/**
 * 세로 중앙 정렬로 높이를 잡지 않는다.
 * 표가 뷰포트보다 길 때 중앙 정렬은 상단을 잘라내고 스크롤로도 되돌아갈 수 없게 만든다.
 * 대신 부모가 준 높이를 그대로 받아 표 안쪽에서만 스크롤시킨다.
 */
export const Wrapper = styled(Stack)`
  width: 100%;
  max-width: 1032px;
  min-height: 0;
  flex: 1;
`;

export const CouponWrapper = styled(Stack)`
  border-radius: 8px;
`;

/* min-height: 0이 없으면 flex 자식이 콘텐츠 높이 아래로 줄지 못해 표가 스크롤되지 않는다. */
export const MatrixWrapper = styled(Stack)`
  overflow: hidden;
  min-height: 0;
  flex: 1;
  border: 1px solid ${({ theme }) => theme.colors.zinc_200};
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 8px;
`;
